<template>
  <div v-if="display">
    <span
      :class="{'on': level >= 10 && live }"
      class="dot"/>
    <span
      :class="{'on': level >= 25 && live }"
      class="dot"/>
    <span
      :class="{'on': level >= 45 && live }"
      class="dot"/>
    <span
      :class="{'on': level >= 55 && live }"
      class="dot"/>
    <span
      :class="{'on': level > 60 && live }"
      class="dot"/>
    <span
      :class="{'on': level > 70 && live }"
      class="dot"/>
    <span
      :class="{'on': level > 80 && live }"
      class="dot"/>
  </div>
</template>
<script>
import { ref, onBeforeUnmount, onMounted, watch } from "@vue/composition-api"
export default {
  name: 'VolumeIndicator',
  props: {
    media: {
      type: MediaStream,
      default: () => new MediaStream
    },
    display: {
      type: Boolean,
      default: false
    },
    live: {
      type: Boolean,
      default: true
    },
    mike: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const level = ref('0.0')
    const levelMikeOn = ref([])
    const supported = ref(false)
    const script = ref({})
    const audioContext = ref({})
    const audio = ref({})
    const mediaClone = ref(null)

    if (!window.AudioContext) {
      if (window.webkitAudioContext) {
        window.AudioContext = window.webkitAudioContext
      }
    }
    if (window.AudioContext) {
      audioContext.value = new window.AudioContext()
      if (audioContext.value) {
        script.value = audioContext.value.createScriptProcessor(2048, 1, 1)
        supported.value = true
      } else {
        console.log('audioContext.value is null')
      }
    } else {
      console.log('Web Audio API not supported.')
    }

    onMounted(() => {
      addMedia()
    })

    onBeforeUnmount(() => {
      removeMedia()
    })

    function getMikeLevel() {
      let level = 0
      let length = levelMikeOn.value.length
      while(levelMikeOn.value.length > 0) {
        level += levelMikeOn.value[levelMikeOn.value.length-1]
        levelMikeOn.value.pop()
      }
      return level/length
    }

    function addMedia () {
      if (mediaClone.value != null) {
        if (mediaClone.value.getAudioTracks().length > 0) {
          console.log("onMounted remove track")
          console.log(mediaClone.value.getAudioTracks())
          mediaClone.value.getAudioTracks()[0].stop()
        }
      }

      mediaClone.value = props.media.clone()
      if(mediaClone.value.getAudioTracks().length > 0){
        mediaClone.value.getAudioTracks()[0].enabled = true
      }

      if (supported.value && window.AudioContext && mediaClone.value.getAudioTracks().length > 0) {
        script.value.onaudioprocess = function (event) {
          let input = event.inputBuffer.getChannelData(0)
          let i
          let sum = 0.0
          for (i = 0; i < input.length; ++i) {
            sum += input[i] * input[i]
          }
          let instantLevel = (200 * Math.sqrt(sum / input.length))
          if (instantLevel < 1) instantLevel = 1.0
          if (instantLevel > 100) instantLevel = 100
          level.value = instantLevel
          levelMikeOn.value.push(props.mike ? instantLevel : 0)
        }

        if (audio.value && typeof audio.value.disconnect === "function") {
          audio.value.disconnect()
        }
        if (script.value && typeof script.value.disconnect === "function") {
          script.value.disconnect()
        }
        audio.value = audioContext.value.createMediaStreamSource(mediaClone.value)
        audio.value.connect(script.value)
        script.value.connect(audioContext.value.destination)
      }
    }

    function removeMedia () {
      if (audio.value && typeof audio.value.disconnect === "function") {
        audio.value.disconnect()
      }
      if (script.value && typeof script.value.disconnect === "function") {
        script.value.disconnect()
      }
      /* if (mediaClone.value != null) {
        if (mediaClone.value.getAudioTracks().length > 0) {
          mediaClone.value.getAudioTracks()[0].stop()
        }
        mediaClone.value = null
      } */
      mediaClone.value = null
    }

    watch( () => props.media, (media) => {
      removeMedia()
      mediaClone.value = media.clone()
      if(mediaClone.value.getAudioTracks().length > 0){
        mediaClone.value.getAudioTracks()[0].enabled = true
      }

      if (supported.value && window.AudioContext && mediaClone.value.getAudioTracks().length > 0) {
        script.value.onaudioprocess = function (event) {
          let input = event.inputBuffer.getChannelData(0)
          let i
          let sum = 0.0
          for (i = 0; i < input.length; ++i) {
            sum += input[i] * input[i]
          }
          let instantLevel = (200 * Math.sqrt(sum / input.length))
          if (instantLevel < 1) instantLevel = 1.0
          if (instantLevel > 100) instantLevel = 100
          level.value = instantLevel
          levelMikeOn.value.push(props.mike ? instantLevel : 0)
        }
        if (audio.value && typeof audio.value.disconnect === "function") {
          audio.value.disconnect()
        }
        if (script.value && typeof script.value.disconnect === "function") {
          script.value.disconnect()
        }
        audio.value = audioContext.value.createMediaStreamSource(mediaClone.value)
        audio.value.connect(script.value)
        script.value.connect(audioContext.value.destination)
      }
    })

    return {
      level,
      supported,
      audioContext,
      audio,
      script,
      mediaClone,
      getMikeLevel,
      addMedia,
      removeMedia
    }
  }
}
</script>
<style>
.dot{
  height: 8px;
  width: 8px;
  background-color: #e6e6e6;
  border-radius: 100%;
  margin-right: 4px;
}
.dot.on{
  background-color: #65ca30;
}
</style>



// WEBPACK FOOTER //
// src/components/VolumeIndicator.vue